import { useQuery } from '@apollo/client';

import { GET_PROJECT_RESET_CONFIG } from '@/graphql/queries';

const useProjectResetConfig = () => {
  const { data, loading } = useQuery(GET_PROJECT_RESET_CONFIG, {
    ssr: false,
  });

  return {
    isLoading: loading && !data,
    data: data?.projectResetConfig,
  };
};

export default useProjectResetConfig;
